export default "__VITE_ASSET__BKPsQSxb__"